import React from 'react';
import { siteConfig } from '@/config/site.config';
import { useI18n } from '@/i18n';

/**
 * Locale picker rendered in the navbar when `siteConfig.i18n.enabled` is
 * `true`. A native `<select>` keeps this accessible (labelled, keyboard- and
 * screen-reader-friendly) without any extra ARIA wiring. See `docs/I18N.md`.
 */
const LanguageSwitcher: React.FC = () => {
    const { locale, setLocale, t } = useI18n();

    if (siteConfig.i18n.locales.length < 2) return null;

    return (
        <label className="language-switcher">
            <span className="sr-only">{t('language.label', 'Language')}</span>
            <select
                value={locale}
                onChange={(e) => setLocale(e.target.value)}
                aria-label={t('language.label', 'Language')}
            >
                {siteConfig.i18n.locales.map(({ code, label }) => (
                    <option key={code} value={code}>
                        {label}
                    </option>
                ))}
            </select>
        </label>
    );
};

export default LanguageSwitcher;
